// Shared config/constants for the chat widget bundle.
export const config = window.humataConfig || {};

export const STORAGE_KEY = 'humata_chat_history';
export const CONVERSATION_KEY = 'humata_conversation_id';
export const THEME_KEY = 'humata_theme_preference';
export const POW_VERIFIED_KEY = 'humata_pow_verified';


